import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import ScrollLock from "react-scrolllock";

import types from "./types";
import { Wrapper, Body } from "./styled/ModalContent";
import Header from "./Header";
import Footer from "./Footer";

class ModalContentComponent extends PureComponent {
  static propTypes = {
    actions: types.actions,
    appearance: types.appearance,
    headerIcon: PropTypes.node,
    heading: PropTypes.string,
    shouldScroll: PropTypes.bool,
    children: PropTypes.node
  };

  static defaultProps = {
    actions: [],
    appearance: "secondary",
    headerIcon: null,
    heading: null,
    shouldScroll: true,
    children: null
  };

  render() {
    const {
      actions,
      appearance,
      children,
      headerIcon,
      heading,
      shouldScroll
    } = this.props;

    return (
      <Wrapper>
        <Header appearance={appearance} heading={heading} icon={headerIcon} />
        <Body ref={this.getScrollContainer} shouldScroll={shouldScroll}>
          {children}
        </Body>
        <Footer actions={actions} appearance={appearance} />
        {shouldScroll && <ScrollLock />}
      </Wrapper>
    );
  }
}

export default ModalContentComponent